import { Component, Inject } from '@angular/core';
import { IconComponent } from "../../helper/icon/icon.component";
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-connect-patreon-fail',
  imports: [IconComponent, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './connect-patreon-fail.component.html',
  styleUrl: './connect-patreon-fail.component.less'
})
export class ConnectPatreonFailComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
